import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import IProductGroupListItem from './IProductGroupListItem';
import { Table, Button, ButtonToolbar } from 'react-bootstrap';
import DeleteButton from '../../../components/common/DeleteButton';

interface ProductGroupListRowProps {
    productGroup: IProductGroupListItem;
    onEdit: (value: IProductGroupListItem) => void;
    onDelete: (value: IProductGroupListItem) => void;
    showLogs: (value: IProductGroupListItem) => void;
}

const ProductGroupListRow = (props: ProductGroupListRowProps) => {
    return (
        <tr key={props.productGroup.id}>
            <td>{props.productGroup.name}</td>
            <td>{props.productGroup.numberOfProducts}</td>
            <td className="tools">
                <ButtonToolbar className="pull-right btn-group-sm">
                    <DeleteButton
                        onDelete={() => props.onDelete(props.productGroup)}
                        text={Translate('product-groups/list/row/delete/remove-this-product-group')}
                    >
                        <i className="material-icons">delete</i>{' '}
                        {Translate('product-groups/list/row/button-label/delete')}
                    </DeleteButton>
                    <Button onClick={() => props.onEdit(props.productGroup)} bsStyle="primary">
                        <i className="material-icons">edit</i>{' '}
                        {Translate('product-groups/list/row/button-label/edit')}
                    </Button>
                    <Button onClick={() => props.showLogs(props.productGroup)} bsStyle="default">
                        <i className="material-icons">list</i>{' '}
                        {Translate('product-groups/list/row/button-label/logs')}
                    </Button>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default ProductGroupListRow;
